module.exports = __webpack_public_path__ + "media/images/icons/plus-f85e9597cf9802099af548b1a239aa7f.svg";